var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { fetchInvoicinglogSuccess, fetchInvoicinglogFailure, FETCH_INVOICING_LOG_REQUEST } from "../../actions";
import APIIN from "@/utils/APIIN";
const onFetchInvoicingLog = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { pageSize, pageNumber } = action.payload;
            APIIN.get(`/report/admin/metadata?pageSize=${pageSize}&pageNumber=${pageNumber}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchInvoicingLogWorker(action) {
    try {
        const data = yield call(onFetchInvoicingLog, action);
        yield put(fetchInvoicinglogSuccess(data));
    }
    catch (error) {
        yield put(fetchInvoicinglogFailure(error));
    }
}
export function* watchInvoicingLogData() {
    yield takeLatest(FETCH_INVOICING_LOG_REQUEST, fetchInvoicingLogWorker);
}
